import styled from "styled-components";

export const FiltrosTurnosContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 24px;
  overflow: auto;
  gap: 10px;
  overflow-y: scroll;
  max-height: 50vh;
`;

export const TituloLineBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 6px;
`;

export const ItemBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
  .title-arrow-box {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .datepickerBox {
    padding: 0 0 20px 0;
    width: 100%;
  }
  .content {
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    visibility: hidden; /* Evita la interacción mientras está oculto */
    transition: max-height 0.3s ease, opacity 0.3s ease, visibility 0s 0.3s; /* Retrasa 'visibility' */
  }

  .content.visible {
    overflow: auto;
    max-height: 500px; /* Ajusta según el contenido */
    opacity: 1;
    visibility: visible;
    transition: max-height 0.3s ease, opacity 0.3s ease, visibility 0s 0s; /* Visibility ocurre inmediatamente */
  }

  .content.hidden {
    max-height: 0;
    opacity: 0;
    visibility: hidden;
  }
`;

export const FlechaContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-right: 8px;
  rotate: -90deg;
  transform: ${(props) => props.$rotate && `rotate(180deg)`};
  transition: 0.2s ease;
`;

export const FiltrosTurnosBtnBox = styled.div`
  padding: 16px 22px;
`;

export const Line = styled.div`
  position: relative; /* Necesario para posicionar los pseudo-elementos */
  height: 1px; /* Altura de la línea */
  width: 100%;
  margin: 0px auto; /* Espaciado superior e inferior */

  &::before {
    content: ""; /* Esto asegura que el pseudo-elemento se renderice */
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px; /* Grosor de la línea */
    background: var(--color-grey90);
    border-radius: 50%;
    transform: translateY(-50%); /* Centra el pseudo-elemento verticalmente */
  }
`;
